// src/components/common/SeeMore.jsx
import React, { useState } from "react";

const SeeMore = ({ 
  text, 
  maxLength = 20,    // adjust as needed
  className = "" 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) {
    return <span className={className}>—</span>;
  }

  if (text.length <= maxLength) {
    return <div className={className}>{text}</div>;
  }

  const truncated = text.slice(0, maxLength).trim();

  return (
    <div className={`whitespace-pre-wrap break-words leading-relaxed ${className}`}>
      {isExpanded ? text : `${truncated}...`}
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="ml-1.5 text-xs font-medium hover:underline transition-colors"
      >
        {isExpanded ? "See less" : "See more"}
      </button>
    </div>
  );
};

export default SeeMore;